<template>
    <div class="bonusomat-board-completed is-dark">
        <div class="ds-modal-dialog__body">
            <div class="ds-modal-dialog__wrap">
                <div class="ds-modal-dialog__container">
                    <DsTopSlotHeadlineSubheadline
                        v-if="isPlayerDataLoaded"
                        :headline="headlineHeadline"
                        :subheadline="headlineSubheadline"
                        :image-src="headlineImage"
                        :image-alt="headlineImageAlt"
                    />
                    <div class="ds-top-slot-headline-subheadline" v-else>
                        <div
                            class="bonusomat-placeholder__skeleton bonusomat-board-completed__title-image-skeleton ds-top-slot-headline-subheadline__image"
                        ></div>
                        <div class="bonusomat-placeholder__skeleton bonusomat-board-completed__title-skeleton"></div>
                    </div>
                    <DsDivider theme="dark" />
                    <template v-if="isPlayerDataLoaded">
                        <div class="bonusomat-board-completed__tickets" v-if="isTicketClaimable">
                            <div class="bonusomat-board-completed__ticket">
                                <WebpImage
                                    :src="bonImgUrl('board/ticket-vertical', 'png')"
                                    alt=""
                                    css-class="bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--vertical"
                                />
                                <WebpImage
                                    :src="bonImgUrl('board/ticket-horizontal', 'png')"
                                    alt=""
                                    css-class="bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--horizontal"
                                />
                                <div class="bonusomat-board-completed__ticket__text-wrapper">
                                    <div
                                        class="bonusomat-board-completed__ticket__text bonusomat-board-completed__ticket__text--prize"
                                    >
                                        <span> {{ formattedPrize }} </span>
                                        <span class="bonusomat-board-completed__ticket__text--small"> Kč </span>
                                    </div>
                                    <div
                                        class="bonusomat-board-completed__ticket__text bonusomat-board-completed__ticket__text--number"
                                    >
                                        {{ defaultDrawData.totalTickets + 1 }}
                                    </div>
                                    <div
                                        class="bonusomat-board-completed__ticket__text bonusomat-board-completed__ticket__text--date"
                                    >
                                        <span class="bonusomat-board-completed__ticket__text--date-mobile"
                                            >{{ dateShort }}&nbsp;</span
                                        >
                                        <span class="bonusomat-board-completed__ticket__text--date-desktop"
                                            >{{ date }}&nbsp;</span
                                        >
                                        <span class="bonusomat-board-completed__ticket__text--small">{{ time }}</span>
                                    </div>
                                </div>
                                <div class="bonusomat-board-completed__ticket__number">
                                    {{ defaultDrawData.totalTickets + 1 }}
                                </div>
                            </div>
                            <div
                                class="bonusomat-board-completed__ticket bonusomat-board-completed__ticket--second"
                                v-if="defaultDrawData.ticketsToWin >= 2"
                            >
                                <WebpImage
                                    :src="bonImgUrl('board/ticket-vertical', 'png')"
                                    alt=""
                                    css-class="bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--vertical"
                                />
                                <WebpImage
                                    :src="bonImgUrl('board/ticket-horizontal', 'png')"
                                    alt=""
                                    css-class="bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--horizontal"
                                />
                            </div>
                            <div
                                class="bonusomat-board-completed__ticket bonusomat-board-completed__ticket--third"
                                v-if="defaultDrawData.ticketsToWin >= 3"
                            >
                                <WebpImage
                                    :src="bonImgUrl('board/ticket-vertical', 'png')"
                                    alt=""
                                    css-class="bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--vertical"
                                />
                                <WebpImage
                                    :src="bonImgUrl('board/ticket-horizontal', 'png')"
                                    alt=""
                                    css-class="bonusomat-board-completed__ticket__image bonusomat-board-completed__ticket__image--horizontal"
                                />
                            </div>
                        </div>
                        <div class="bonusomat-board-completed__no-ticket" v-else>
                            <WebpImage
                                class="bonusomat-board-completed__no-ticket__image-wrapper"
                                css-class="bonusomat-board-completed__no-ticket__image"
                                :src="bonImgUrl('board/mr-green-bonusomat', 'png')"
                                alt="Pan Zelený s Bonusomatem"
                            />
                            <div>
                                <h3 class="bonusomat-board-completed__no-ticket__title">
                                    Nejdřív si ale vytočte všechny odměny Bonusomatu.
                                </h3>
                                <p class="bonusomat-board-completed__no-ticket__perex">
                                    Převzetím {{ wordTiket2pad }} se celá hra resetuje, převezměte si své odměny, abyste
                                    o ně nepřišel.
                                    <br />
                                    <br />
                                    Následně již nebude nic bránit tomu vás obdarovat {{ wordTiket7pad }} do Losovačky
                                    Bonusomatu.
                                    <br />
                                    <br />
                                    Zasloužíte si {{ wordHe4pad }}.
                                </p>
                            </div>
                        </div>
                    </template>
                    <div class="bonusomat-board-completed__no-ticket" v-else>
                        <div
                            class="bonusomat-placeholder__skeleton bonusomat-board-completed__image-skeleton bonusomat-board-completed__no-ticket__image"
                        ></div>
                        <div>
                            <div
                                class="bonusomat-placeholder__skeleton bonusomat-board-completed__ticket-title-skeleton"
                            ></div>
                            <div
                                class="bonusomat-placeholder__skeleton bonusomat-board-completed__ticket-perex-skeleton"
                            ></div>
                            <div
                                class="bonusomat-placeholder__skeleton bonusomat-board-completed__ticket-perex-skeleton"
                            ></div>
                            <br />
                            <div
                                class="bonusomat-placeholder__skeleton bonusomat-board-completed__ticket-perex-skeleton"
                            ></div>
                            <div
                                class="bonusomat-placeholder__skeleton bonusomat-board-completed__ticket-perex-skeleton"
                            ></div>
                        </div>
                    </div>
                    <template v-if="isTicketClaimable && isPlayerDataLoaded">
                        <DsDivider theme="dark" />
                        <DsBottomSlotActionBar
                            :btn-submit-text="'Převzít ' + wordTiket4pad"
                            :button-submit-icon="{ iconRight: 'check' }"
                            :has-btn-close="false"
                            theme="dark"
                            @submit-dialog="completeBoard"
                        />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import DsDivider from "@sazka/design-system/src/divider/ds-divider.vue";
import DsTopSlotHeadlineSubheadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import DsBottomSlotActionBar from "@sazka/design-system/src/bottom-slot/ds-bottom-slot-action-bar.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";

import { bonImgUrl } from "../../utils/image-src";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";

import useBonusomatData from "../../composables/use-bonusomat-data";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { isPlayerDataLoaded, remainingSpinsCount } = bonusomatPlayerStatus;

const { defaultDrawData, completeBoard } = useBonusomatData();

const isTicketClaimable = computed(() => remainingSpinsCount.value === 0);

const formatPrice = (price: number, separator: string) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

// HEADLINE PROPS
const wordTiket2pad = computed(() => (defaultDrawData.value.ticketsToWin > 1 ? "tiketů" : "tiketu"));
const wordTiket4pad = computed(() => (defaultDrawData.value.ticketsToWin > 1 ? "tikety" : "tiket"));
const wordTiket7pad = computed(() => (defaultDrawData.value.ticketsToWin > 1 ? "tikety" : "tiketem"));
const wordHe4pad = computed(() => (defaultDrawData.value.ticketsToWin > 1 ? "je" : "ho"));
const headlineImage = computed(() =>
    isTicketClaimable.value ? bonImgUrl("board/mr-green", "png") : bonImgUrl("board/ticket-waiting", "png")
);
const headlineImageAlt = computed(() => (isTicketClaimable.value ? "Pan Zelený" : "Tiket do Losovačky"));
const headlineHeadline = computed(() =>
    isTicketClaimable.value
        ? "Gratulujeme! Získáváte " + wordTiket4pad.value + " do Losovačky!"
        : "Už jste jen malý krůček od získání " + wordTiket2pad.value + " do Losovačky!"
);
const headlineSubheadline = computed(() =>
    isTicketClaimable.value
        ? "Splnit 48 úkolů musela být pořádná fuška, ale teď máte šanci v naší Losovačce vyhrát " +
          formatPrice(defaultDrawData.value.mainWin, "&nbsp;") +
          "&nbsp;Kč!"
        : null
);

const formattedPrize = computed(() => {
    return formatPrice(defaultDrawData.value.mainWin, ".");
});

const dateShort = computed(() => {
    return DateTimeUtils.formatDate(defaultDrawData.value.drawDate, "2-digit");
});

const date = computed(() => {
    return DateTimeUtils.formatDate(defaultDrawData.value.drawDate);
});

const time = computed(() => {
    return DateTimeUtils.formatTime(defaultDrawData.value.drawDate);
});
</script>
